import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function NextStepModal({
  isOpen,
  warrantySteps,
  status,
  onNextStep,
  onClose,
}) {
  if (!warrantySteps[status]) return null;
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Continue to next step of warranty"
      className="confirm-modal"
      style={{ overlay: { zIndex: 10 } }}
    >
      <button onClick={onClose} className="confirm-modal-close">
        <MdClose />
      </button>
      <div className="confirm-main-text">
        {warrantySteps[status].modalText}
      </div>
      <div>
        <button onClick={onNextStep} className="btn btn-outline-primary mr-3">
          Yes
        </button>
        <button className="btn btn-outline-secondary" onClick={onClose}>
          No
        </button>
      </div>
    </Modal>
  );
}
